<template>
<div class="AddFriendBtn">
    <button class="feed__icon"
            :class="{'active': isFriend }"
            :disabled="loading"
            @click="addFriend">
        <div v-if="loading" class="spinner-border" />
        <img v-else-if="isFriend" src="@assets/imgs/exchange/connect_confirmed.png" alt="Connecteds">
        <img v-else-if="isRequested" class="requested" src="@assets/imgs/exchange/connect.png" alt="Connect Request Sent">
        <img v-else src="@assets/imgs/exchange/connect.png" alt="Connect">

        <span v-if="!short">{{ btnText }}</span>
    </button>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import {addFriend} from "@api/api.friends";

    export default {
        name: "AddFriendBtn",
        props: {
            user: {type: Object, default: () => {}},
            short: {type: Boolean, default: false},
        },
        data() {
            return {
                loading: false,
                mouseover: false,
            }
        },
        computed: {
            ...mapGetters('auth', {
                currentUser: 'getCurrentUser'
            }),
            friendStatus() {
                return this.user.friend_status
            },
            isFriend() {
                return this.user.is_friend || this.friendStatus === 'approved'
            },
            isRequested() {
                return this.friendStatus === 'pending'
            },
            btnText() {
                if (this.isFriend) {
                    return 'Connected'
                } else if (this.friendStatus === 'awaiting') {
                    return 'Approve'
                } else if (this.friendStatus === 'pending') {
                    return 'Pending'
                } else {
                    return 'Connect'
                }
            },
        },
        methods: {
            async addFriend() {
                this.loading = true
                const response = await addFriend({user_id: this.user.id })
                this.loading = false
                this.$toast.success(response.data.message)
                const { friend_status, is_friend } = response.data.response
                this.$emit('is_friend', is_friend)
                this.$emit('friend_status', friend_status)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .add-friend-btn-component {
        font-size: 26px;
        .btn {
            white-space: nowrap;
            padding: 0 1.5rem;
            &.active {
                &:hover {
                    background: #e4e2f1;
                    border-color: #e4e2f1;
                    color: #8A7A5E;
                }
            }
            & > * {
                vertical-align: middle;
                line-height: 26px;
            }
            .icon-add-a-friend, icon-friend-confirmed {
                font-size: 2.6rem;
            }
        }
        .spinner-border {
            opacity: 0.4;
        }
    }
</style>